// extracted by mini-css-extract-plugin
module.exports = {"main":"order-info-page_main__3POTC"};